import api from './api';

// LitigationEvent + ComputedDeadline API (Session 6B). Uses the shared `api` axios client,
// so the JWT (and thus tenant scope) is attached automatically.
const litigationEventService = {
  // ---- events ----
  listEvents: async (caseId) => {
    const res = await api.get(`/litigation-events?case_id=${encodeURIComponent(caseId)}`);
    return res.data;
  },
  createEvent: async (payload) => {
    const res = await api.post('/litigation-events', payload);
    return res.data;
  },
  updateEvent: async (eventId, payload) => {
    const res = await api.patch(`/litigation-events/${eventId}`, payload);
    return res.data;
  },
  deleteEvent: async (eventId) => {
    await api.delete(`/litigation-events/${eventId}`);
  },

  // ---- persisted deadlines ----
  listDeadlines: async (caseId, includeResolved = false) => {
    const res = await api.get(
      `/litigation-deadlines?case_id=${encodeURIComponent(caseId)}&include_resolved=${includeResolved}`);
    return res.data;
  },
  acknowledgeDeadline: async (deadlineId) => {
    const res = await api.post(`/litigation-deadlines/${deadlineId}/acknowledge`);
    return res.data;
  },
  resolveDeadline: async (deadlineId) => {
    const res = await api.post(`/litigation-deadlines/${deadlineId}/resolve`);
    return res.data;
  },
};

export default litigationEventService;
